import { render, staticRenderFns } from "./ScriptLoadingText.vue?vue&type=template&id=4fcb6e5a&scoped=true&"
import script from "./ScriptLoadingText.vue?vue&type=script&lang=js&"
export * from "./ScriptLoadingText.vue?vue&type=script&lang=js&"
import style0 from "./ScriptLoadingText.vue?vue&type=style&index=0&id=4fcb6e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb6e5a",
  null
  
)

export default component.exports